"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CacheEntry {
    constructor(value) {
        this.value = value;
    }
    isEmpty() {
        return this.value === undefined;
    }
    isPresent() {
        return !this.isEmpty();
    }
    get() {
        if (this.isEmpty()) {
            throw new Error('Cannot get value from empty entry');
        }
        return this.value;
    }
    orElse(otherValue) {
        return this.value ? this.value : otherValue;
    }
    map(func) {
        if (this.isEmpty()) {
            return CacheEntry.EMPTY;
        }
        return CacheEntry.of(func(this.value));
    }
    static of(value) {
        if (!value) {
            return CacheEntry.EMPTY;
        }
        return new CacheEntry(value);
    }
}
CacheEntry.EMPTY = new CacheEntry(undefined);
exports.default = CacheEntry;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FjaGVFbnRyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdGF0aWMtZGF0YS1zZXJ2aWNlL0NhY2hlRW50cnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxNQUFxQixVQUFVO0lBRzdCLFlBQXFDLEtBQVM7UUFBVCxVQUFLLEdBQUwsS0FBSyxDQUFJO0lBQzlDLENBQUM7SUFFRCxPQUFPO1FBQ0wsT0FBTyxJQUFJLENBQUMsS0FBSyxLQUFLLFNBQVMsQ0FBQztJQUNsQyxDQUFDO0lBRUQsU0FBUztRQUNQLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUM7SUFDekIsQ0FBQztJQUVELEdBQUc7UUFDRCxJQUFJLElBQUksQ0FBQyxPQUFPLEVBQUUsRUFBRSxDQUFDO1lBQ25CLE1BQU0sSUFBSSxLQUFLLENBQUMsbUNBQW1DLENBQUMsQ0FBQztRQUN2RCxDQUFDO1FBRUQsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQ3BCLENBQUM7SUFFRCxNQUFNLENBQUMsVUFBYTtRQUNsQixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLFVBQVUsQ0FBQztJQUM5QyxDQUFDO0lBRUQsR0FBRyxDQUFJLElBQXFCO1FBQzFCLElBQUksSUFBSSxDQUFDLE9BQU8sRUFBRSxFQUFFLENBQUM7WUFDbkIsT0FBTyxVQUFVLENBQUMsS0FBSyxDQUFDO1FBQzFCLENBQUM7UUFFRCxPQUFPLFVBQVUsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFFRCxNQUFNLENBQUMsRUFBRSxDQUFJLEtBQVE7UUFDbkIsSUFBSSxDQUFDLEtBQUssRUFBRSxDQUFDO1lBQ1gsT0FBTyxVQUFVLENBQUMsS0FBSyxDQUFDO1FBQzFCLENBQUM7UUFFRCxPQUFPLElBQUksVUFBVSxDQUFJLEtBQUssQ0FBQyxDQUFDO0lBQ2xDLENBQUM7O0FBdkNlLGdCQUFLLEdBQUcsSUFBSSxVQUFVLENBQUMsU0FBUyxDQUFDLENBQUM7a0JBRC9CLFVBQVUifQ==